var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTagSolid = function SvgTagSolid(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_136",
    "data-name": "Subtra\\xE7\\xE3o 136",
    d: "M7.915,16a1.351,1.351,0,0,1-.959-.4L.4,9.073a1.348,1.348,0,0,1,0-1.911L6.733.909a2.9,2.9,0,0,1,2.26-.9L14.709,0a1.251,1.251,0,0,1,.927.4A1.4,1.4,0,0,1,16,1.359v5.4a3.6,3.6,0,0,1-.678,2.477L8.874,15.6A1.351,1.351,0,0,1,7.915,16ZM12.75,2A1.25,1.25,0,1,0,14,3.25,1.249,1.249,0,0,0,12.75,2Z",
    transform: "translate(-0.001)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTagSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag-solid.f2c14252.svg";
export { ForwardRef as ReactComponent };